module.exports = __webpack_public_path__ + "static/img/caiyun.4878a28c.png";